// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3d_1B","tab":"Tabs_tab__10rru","tabActive":"Tabs_tabActive__1MwoX"};